import React from 'react';
import {TextQuestionTitle} from "./text-question-title/TextQuestionTitle";

import {CorrectOrder} from "./correct-order/CorrectOrder";
import {AuditionTitle} from "./audition-title/AuditionTitle";
import {ImageTitle} from "./image-title/ImageTitle";
import {useAppSelector} from "common/hook";

interface IInTheForm {
    activeTab: string
}

export const InTheForm = ({activeTab}: IInTheForm) => {
    const testItemsData = useAppSelector(state => state.testViewAnswerId.serverData?.data?.model?.testItems);

    const renderDetermineProcedure = (testItem: any, index: number) => (
        <CorrectOrder testItem={testItem} key={testItem.id} index={index}/>
    );

    const renderTextType = (testItem: any, index: number) => (
        <TextQuestionTitle testItem={testItem} key={testItem.id} index={index}/>
    );

    const renderAudioType = (testItem: any, index: number) => (
        <AuditionTitle testItem={testItem} key={testItem.id} index={index}/>
    );

    const renderImageType = (testItem: any, index: number) => (
        <ImageTitle testItem={testItem} key={testItem.id} index={index}/>
    );

    const renderQuestionByTabType = (testItem: any, index: number) => {
        if (testItem.questionType === "determineProcedure") {
            return renderDetermineProcedure(testItem, index);
        }

        switch (testItem.tabType) {
            case "textType":
                return renderTextType(testItem, index);
            case "audioType":
                return renderAudioType(testItem, index);
            case "imageType":
                return renderImageType(testItem, index);
            default:
                return null;
        }
    };

    return (
        <div className={`test-descr-box ${activeTab === 'inForm' ? '' : 'text-view'}`}>
            {testItemsData?.map((item, index) => (
                <div key={item.id}>
                    {renderQuestionByTabType(item, index)}
                    <hr/>
                </div>
            ))}
        </div>
    );
};

